<template>
  <div class="page">
    <navigation
      class="header"
      :theme="{
        background: '#fff',
      }"
    >账号注销
    </navigation>
    <div class="content-container">
      <div class="content">
        <div class="title">风险提示：</div>
        <div class="sub-title">一经注销，无法使用</div>
        <div>您在享惠借注册帐号为您当前手机号</div>
        <div>一旦注销，额度自动失效，您将无法使用该帐号</div>
        <div>当前手机号关联身份实名信息等无法在平台有效使用</div>
      </div>
    </div>
    <nd-button @click="continueSignout" style="background: linear-gradient( 270deg, #FF9551 0%, #FB571C 100%);">已知悉风险，继续注销</nd-button>
  </div>
</template>

<script>
export default {
  async created () {
    this.$bus.$emit('ready')
  },
  data () {
    return {
    }
  },

  methods: {
    continueSignout () {
      this.$router.push('/se/signout/auth')
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../../assets/less/mixin.less";

.page {
  width: 750px;
  height: 100%;
  background: #fafafa;
  .content-container {
    background: #fff;
    width: 100%;
    margin-top: 20px;
    .content {
      background: #fff;
      width: 100%;
      font-family: PingFangSC-Regular, PingFang SC;
      font-size: 28px;
      color: #666;
      line-height: 48px;
      padding: 50px 40px;
      .title {
        font-size: 36px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333;
        line-height: 50px;
      }
      .sub-title {
        font-size: 28px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333;
      }
    }
    .section2 {
      padding: 30px 40px 50px;
    }
  }
  .nd-button {
    margin: 120px auto;
  }
}
</style>